import { apiBot, queryBot } from 'boot/axios';
import { parseJson } from 'src/mixins/utils';

// eslint-disable-next-line import/prefer-default-export
export async function fetchQuestionsByActivity (activityId) {
    if (!activityId) return;
    return await apiBot.post('activityTests.php', JSON.stringify({
        query: 'fetch-questions-by-activity',
        activityId,
    })).then(r => [].concat(r?.data));
}

// eslint-disable-next-line import/prefer-default-export
export async function insertQuestionAnswers (questionId, answers, isNewAnswers) {
    if (!answers?.length) return;
    const values = answers.reduce((acc, answer) => {
        const label = answer.label ? answer.label.replace(/'/gui, "\\'") : '';
        const value = answer.value ? answer.value.replace(/'/gui, "\\'") : '';
        // С флагом isNewAnswers всегда создаем, как новые записи
        return `${acc}(${isNewAnswers ? null : answer.id || null}, ${questionId}, '${label}', '${value}'), `;
    }, '');
    await queryBot(`
        insert into test_question_answers
        (id, questionId, label, value)
        values ${values.slice(0, values.length - 2)}
        on duplicate key update
            label = values(label),
            value = values(value);
    `);
}

// eslint-disable-next-line import/prefer-default-export
export async function copyTestQuestionsByActivity (oldActivityId, newActivityId) {
    if (!oldActivityId || !newActivityId) return;
    await apiBot.post('activityTests.php', JSON.stringify({
        query: 'copy-test-questions-by-activity',
        oldActivityId,
        newActivityId,
    }));
}

class CalculateTestResult {
    // eslint-disable-next-line no-useless-constructor,no-empty-function
    constructor () {}

    getQuestionResult (q, operatorData = null) {
        if (!q.response) return 0;
        if (['input', 'photo', 'file', 'chat'].includes(q.question.type)) {
            if (operatorData) {
                const { result, userChatId, callback } = operatorData;
                callback(q.id, userChatId, result);
                return result;
            }
            return 1;
        }
        if (['options', 't-poll-single'].includes(q.question.type)) {
            return +q.response.value;
        }
        if (q.question.type === 't-poll-multi') {
            const answers = Array.isArray(q?.answers) ? q.answers : parseJson(q?.answers, []);
            const totalCorrectAnswers = answers.filter(a => a.value === '1')?.length || 0;
            if ((q.response?.length || 0) < totalCorrectAnswers) return 0;

            let incorrect = false;
            _.each(q.response, (r) => {
                if (r.checked === undefined) {
                    if (r.value === '0') incorrect = true;
                    return;
                }
                if ((r.value === '0' && r.checked) || (r.value === '1' && !r.checked)) {
                    incorrect = true;
                }
            });
            return incorrect ? 0 : 1;
        }

        return 0;
    }

    getSumResult (questions = []) {
        return questions.reduce((acc, question) => {
            const result = this.getQuestionResult(question);
            return acc + result;
        }, 0);
    }

    getScore (activity) {
        const sumResult = this.getSumResult(activity.questions);
        const userQuestionsLength = activity.questions.slice(0, activity.maxQuestions || activity.questions.length).length || 1;
        let score = ((sumResult * 100) / userQuestionsLength).toFixed(0);
        if (score > 100) score = 100;
        return score;
    }
}

export const calculateTestResult = new CalculateTestResult();
